import { Image } from '@chakra-ui/react';
import { getTenantByHost } from '@pelicargo/tenants';
import { Show } from '@pelicargo/ui';

import { useCustomerAsset } from '../../hooks/tenant/useCustomerAsset';
import { useCustomerLogoDims } from '../../hooks/tenant/useCustomerLogoDims';

type Props = {
  slot?: 'logo' | 'logoFooter';
  height?: number;
  width?: number;
  fullSized?: boolean;
};

export const Logo = ({ slot = 'logo', height, width, fullSized }: Props) => {
  const src = useCustomerAsset(slot);
  const dims = useCustomerLogoDims(fullSized);
  const { name } = getTenantByHost();

  // A tenant can remove a logo slot outright - most often `logoFooter`. Rendering no element at
  // all, rather than an `<Image>` with no `src`, which would show the alt text instead.
  const showLogo = !!src;

  return (
    <Show if={showLogo}>
      <Image
        src={src}
        height={height ?? dims.height}
        width={width ?? dims.width}
        objectFit="contain"
        alt={`${name} Logo`}
      />
    </Show>
  );
};
